import React from "react";
import NavigateButton from "./ActionsButton/NavigateButton";
import { useTranslation } from "react-i18next";

// Navigation ("drill-in") actions for a test row. Rendered as a fragment so the
// parent row can place them in a single wrapping action cluster.
const RowActions = React.memo(({ test }) => {
  const { t } = useTranslation();

  return (
    <>
      <NavigateButton test={test} path="/scope">
        {t("scopes")}
      </NavigateButton>
      <NavigateButton test={test} path="/reorder">
        {t("sortBy")}
      </NavigateButton>
      <NavigateButton test={test} path="/info">
        {t("applicationInfo")}
      </NavigateButton>
      <NavigateButton test={test} path="/scheme">
        {t("scheme")}
      </NavigateButton>
    </>
  );
});

export default RowActions;
